import React, { useState } from 'react';
import { User } from '../../types/auth';
import { updateUserSettings } from '../../services/profileService';

interface SettingsProps {
  user: User;
}

export default function Settings({ user }: SettingsProps) {
  const [language, setLanguage] = useState(user.preferredLanguage || 'en');
  const [theme, setTheme] = useState<'light' | 'dark'>('dark');
  const [emailNotifications, setEmailNotifications] = useState(true);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [error, setError] = useState('');

  const handleSave = async (e: React.FormEvent) => {
    e.preventDefault();
    setSaving(true);
    setError('');
    setSaved(false);
    try {
      await updateUserSettings(user.id, { preferredLanguage: language, theme, emailNotifications });
      setSaved(true);
    } catch (err: any) {
      setError(err.message || 'Failed to save settings');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="profile-section">
      <h3 className="profile-section-title">Settings</h3>

      {error && <div className="modal-error">{error}</div>}
      {saved && <div className="modal-success">Settings saved successfully.</div>}

      <form onSubmit={handleSave} className="settings-form">
        <label className="auth-label">
          Preferred Language
          <select
            className="auth-input"
            value={language}
            onChange={e => setLanguage(e.target.value)}
          >
            <option value="en">English</option>
            <option value="es">Español</option>
            <option value="fr">Français</option>
            <option value="de">Deutsch</option>
            <option value="zh">中文</option>
            <option value="ja">日本語</option>
          </select>
        </label>

        <label className="auth-label">
          Theme
          <select
            className="auth-input"
            value={theme}
            onChange={e => setTheme(e.target.value as 'light' | 'dark')}
          >
            <option value="dark">Dark</option>
            <option value="light">Light</option>
          </select>
        </label>

        <div className="settings-toggle-row">
          <span>Email Notifications</span>
          <label className="toggle-switch">
            <input
              type="checkbox"
              checked={emailNotifications}
              onChange={e => setEmailNotifications(e.target.checked)}
            />
            <span className="toggle-slider" />
          </label>
        </div>

        <button type="submit" className="btn-primary" disabled={saving}>
          {saving ? 'Saving…' : 'Save Settings'}
        </button>
      </form>
    </div>
  );
}
